import React, { Component } from 'react';
import { connect } from 'react-redux';
import getSelectedFlightsCombinations from 'state/checkoutPage/flights/selectors/getSelectedFlightsCombinations';
import transformFlightsCombinationsForUI from 'state/checkoutPage/flights/transforms/transformFlightsCombinationsForUI';
import FlightsSummary from './FlightsSummary';

class FlightsSummaries extends Component {
  render() {
    const { summaryType, airportNamesMap, carrierNamesMap, getSelectedFlightsCombinations } = this.props;
    const selectedFlightsCombinations = getSelectedFlightsCombinations();

    if (selectedFlightsCombinations === null) {
      return null;
    }

    const flightsCombinations = selectedFlightsCombinations.map((flightsCombination) =>
      transformFlightsCombinationsForUI(flightsCombination, airportNamesMap, carrierNamesMap)
    );

    return (
      flightsCombinations &&
      flightsCombinations.map((flightsCombination, index) => (
        <FlightsSummary
          key={`summary-flights-${selectedFlightsCombinations[index].productToken}`}
          summaryType={summaryType}
          productToken={selectedFlightsCombinations[index].productToken}
          flightsCombination={flightsCombination}
        />
      ))
    );
  }
}

function mapStateToProps(state) {
  return {
    airportNamesMap: state.checkoutPageFlights.airportNamesMap,
    carrierNamesMap: state.checkoutPageFlights.carrierNamesMap,
    selectedFlights: state.checkoutPageTravelSummary.selectedFlights, // Required for component update
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSelectedFlightsCombinations() {
      return dispatch(getSelectedFlightsCombinations());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightsSummaries);
